import { useContext } from "react";
import { Button, Icon } from "@utp/react-components-prod";
import EvaluationContext from "features/Evaluation/context";

interface IButtonEvaluationProps {
  disabled: boolean;
}
const ButtonEvaluation = ({ disabled }: IButtonEvaluationProps) => {
  const { handleNextQuestion, question, isMinorTablet } =
    useContext(EvaluationContext);
  const textButton = question.isLastQuestion
    ? "Finalizar examen"
    : "Siguiente pregunta";
  const sizeButton = `mt-3 ${isMinorTablet ? "w-full" : "w-fit"} ${disabled ? "cursor-not-allowed" : ""}`;
  const divContainer = `flex  justify-end  mt-20 flex-col ${
    isMinorTablet ? "items-center" : "items-end"
  }`;
  return (
    <div className={divContainer}>
      <div className="">
        <span className="text-color-02 flex items-center">
          <Icon iconName="info" size={20} className="mr-2 text-color-icon" />
          Recuerda que no podrás regresar a la pregunta anterior
        </span>
      </div>
      <Button
        color="primary"
        text={textButton}
        disabled={disabled}
        className={sizeButton}
        data-testid="btn-next-question"
        onClick={disabled ? ()=>{} : () => handleNextQuestion()}
      />
    </div>
  );
};

export default ButtonEvaluation;
